import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import LanguageSwitcher from '../components/LanguageSwitcher';

export default function SignIn() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = translations[language];
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleGoogleSignIn = async () => {
    try {
      await authService.googleSignIn();
    } catch (err) {
      setError(t.auth.googleSignInFailed);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await authService.login(email, password);
      
      authService.saveAuth(data.token, data.user);
      const role = data.user?.role;
      if (role === 'student') navigate('/studio/student');
      else if (role === 'teacher') navigate('/studio/teacher');
      else navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      {/* Language Switcher - Top Right */}
      <div style={{ position: 'absolute', top: '20px', right: '20px', zIndex: 100 }}>
        <LanguageSwitcher />
      </div>

      <div className="auth-container" style={{ position: 'relative' }}>
        {/* Close button — returns to homepage */}
        <button
          onClick={() => navigate('/')}
          aria-label="Close"
          style={{
            position: 'absolute', top: '1rem', right: '1rem',
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#aaa', fontSize: '1.4rem', lineHeight: 1,
            padding: '0.2rem 0.4rem', borderRadius: 6,
            transition: 'color 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#333'}
          onMouseLeave={e => e.currentTarget.style.color = '#aaa'}
        >✕</button>

        <div className="auth-header">
          <div className="logo" onClick={() => navigate('/')}>
            <span className="logo-icon">🎬</span>
            <span className="logo-text">AnimLearn</span>
          </div>
          <h1>{t.auth.welcomeBack}</h1>
          <p>{t.auth.signInToContinue}</p>
        </div>

        <button onClick={handleGoogleSignIn} className="btn-google-auth" disabled={loading}>
          <svg className="google-icon" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          {t.auth.continueWithGoogle}
        </button>

        <div className="divider">
          <span>{t.or}</span>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="email">{t.auth.email}</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">{t.auth.password}</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? t.auth.signingIn : t.auth.signInButton}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            {t.auth.dontHaveAccount}{' '}
            <span onClick={() => navigate('/signup')} className="link">
              {t.signUp}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
